(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[105],{

/***/ 52408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(__webpack_require__(45243)) :
	0;
}(this, (function (L) { 'use strict';

	L.Icon.Default.mergeOptions({
		// Erase default options, so that they can be overridden by _initializeOptions if not supplied.
		iconUrl: null,
		iconRetinaUrl: null,
		shadowUrl: null,
		iconSize: null,
		iconAnchor: null,
		popupAnchor: null,
		tooltipAnchor: null,
		shadowSize: null,

		// @option classNamePrefix: String = 'leaflet-default-icon-'
		// Prefix for the classes defined in CSS that contain the Icon options.
		// See the leaflet-defaulticon-compatibility.css file as a starter.
		// Expected suffixes are "icon", "shadow", "popup" and "tooltip".
		classNamePrefix: 'leaflet-default-icon-',
	});


	L.Icon.Default.include({

		_needsInit: true,

		// Override to make sure options are retrieved from CSS.
		_getIconUrl: function (name) {
			// @option imagePath: String
			// `Icon.Default` will try to auto-detect the location of
			// the blue icon images. If you are placing these images in a
			// non-standard way, set this option to point to the right
			// path, before any marker is added to a map.
			// Caution: do not use this option with inline base64 image(s).
			var imagePath = this.options.imagePath || L.Icon.Default.imagePath || '';
			// Deprecated (IconDefault.imagePath), backwards-compatibility only

			if (this._needsInit) {
				// Modifying imagePath option after _getIconUrl has been called
				// once in this instance of IconDefault will no longer have any
				// effect.
				this._initializeOptions(imagePath);
			}

			return imagePath + L.Icon.prototype._getIconUrl.call(this, name);
		},

		// Initialize all necessary options for this instance.
		_initializeOptions: function (imagePath) {
			this._setOptions('icon', _detectIconOptions, imagePath);
			this._setOptions('shadow', _detectIconOptions, imagePath);
			this._setOptions('popup', _detectDivOverlayOptions);
			this._setOptions('tooltip', _detectDivOverlayOptions);
			this._needsInit = false;
		},

		// Retrieve values from CSS and assign to this instance options.
		_setOptions: function (name, detectorFn, imagePath) {
			var options = this.options,
			    prefix = options.classNamePrefix,
			    optionValues = detectorFn(prefix + name, imagePath);

			for (var optionName in optionValues) {
				options[name + optionName] = options[name + optionName] || optionValues[optionName];
			}
		}

	});


	// Retrieve icon option values from CSS (icon or shadow).
	function _detectIconOptions(className, imagePath) {
		var el = L.DomUtil.create('div',  className, document.body),
		    urlsContainer = _getBkgImageOrCursor(el),
		    urls = _extractUrls(urlsContainer, imagePath),
		    iconX = _getStyleInt(el, 'width'),
		    iconY = _getStyleInt(el, 'height'),
		    anchorNX = _getStyleInt(el, 'margin-left'),
		    anchorNY = _getStyleInt(el, 'margin-top');

		el.parentNode.removeChild(el);

		return {
			Url: urls[0],
			RetinaUrl: urls[1],
			Size: [iconX, iconY],
			Anchor: [-anchorNX, -anchorNY]
		};
	}

	// Retrieve anchor option values from CSS (popup or tooltip).
	function _detectDivOverlayOptions(className) {
		var el = L.DomUtil.create('div', className, document.body),
		    anchorX = _getStyleInt(el, 'margin-left'),
		    anchorY = _getStyleInt(el, 'margin-top');

		el.parentNode.removeChild(el);

		return {
			Anchor: [anchorX, anchorY]
		};
	}

	// Read the CSS url (could be path or inline base64), may be multiple.
	// First: normal icon
	// Second: Retina icon
	function _extractUrls(urlsContainer, imagePath) {
		var re = /url\(['"]?([^"']*?)['"]?\)/gi, // Match anything between url( and ), possibly with single or double quotes.
		    urls = [],
		    m = re.exec(urlsContainer);

		while (m) {
			// Keep the entire URL from CSS rule, so that each image can have its own full URL.
			// Except in the case imagePath is provided: remove the path part (i.e. keep only the file name).
			urls.push(imagePath ? _stripPath(m[1]) : m[1]);
			m = re.exec(urlsContainer);
		}

		return urls;
	}

	// Remove anything before the last slash (/) occurrence (inclusive).
	// Caution: will give unexpected result if url is inline base64 data
	// => do not specify imagePath in that case!
	function _stripPath(url) {
		return url.substr(url.lastIndexOf('/') + 1);
	}

	function _getStyleInt(el, style) {
		return parseInt(_getStyle(el, style), 10);
	}

	// Factorize style reading fallback for IE8.
	function _getStyle(el, style) {
		return L.DomUtil.getStyle(el, style) || L.DomUtil.getStyle(el, _kebabToCamelCase(style));
	}

	// When Firefox high contrast (colours override) option is enabled,
	// "background-image" is overridden by the browser as "none".
	// In that case, fallback to "cursor". But keep "background-image"
	// as primary source because IE expects cursor URL as relative to HTML page
	// instead of relative to CSS file.
	function _getBkgImageOrCursor(el) {
		var bkgImage = _getStyle(el, 'background-image');

		return bkgImage && bkgImage !== 'none' ? bkgImage : _getStyle(el, 'cursor');
	}

	// Convert kebab-case CSS property name to camelCase for IE currentStyle.
	function _kebabToCamelCase(prop) {
		return prop.replace(/-(\w)/g, function (str, w) {
			return w.toUpperCase();
		});
	}

})));


/***/ }),

/***/ 27105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PartnerAreaMap; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5715);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52013);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25996);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20577);
/* harmony import */ var react_leaflet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32604);
/* harmony import */ var leaflet_defaulticon_compatibility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52408);
/* harmony import */ var leaflet_defaulticon_compatibility__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(leaflet_defaulticon_compatibility__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




function PartnerAreaMap(param) {
    var team = param.team;
    var map = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var groupRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var latLng = [
        team.basements[0] ? team.basements[0].lat : team.lat,
        team.basements[0] ? team.basements[0].lng : team.lng
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setTimeout(function() {
            if (groupRef.current) {
                var group = groupRef.current; // get native featureGroup instance
                map.current.fitBounds(group.getBounds());
            }
        }, 500);
    }, []);
    return team.lat && team.lng && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-full overflow-hidden",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_leaflet__WEBPACK_IMPORTED_MODULE_3__/* .MapContainer */ .h, {
            center: latLng,
            zoom: 9,
            ref: map,
            scrollWheelZoom: false,
            style: {
                height: '100%',
                width: '100%'
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_leaflet__WEBPACK_IMPORTED_MODULE_4__/* .TileLayer */ .I, {
                    attribution: "\xa9 <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors",
                    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_leaflet__WEBPACK_IMPORTED_MODULE_5__/* .FeatureGroup */ .$, {
                    ref: groupRef,
                    children: team.basements.map(function(b) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_leaflet__WEBPACK_IMPORTED_MODULE_6__/* .Marker */ .J, {
                            position: [
                                b.lat,
                                b.lng
                            ],
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_leaflet__WEBPACK_IMPORTED_MODULE_7__/* .Popup */ .G, {
                                children: b.name
                            })
                        }, b.id);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 1410:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hb": function() { return /* binding */ createLeafletContext; },
/* harmony export */   "sj": function() { return /* binding */ extendContext; },
/* harmony export */   "UO": function() { return /* binding */ LeafletProvider; },
/* harmony export */   "mE": function() { return /* binding */ useLeafletContext; }
/* harmony export */ });
/* unused harmony exports CONTEXT_VERSION, LeafletContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const CONTEXT_VERSION = 1;
function createLeafletContext(map) {
    return Object.freeze({
        __version: CONTEXT_VERSION,
        map
    });
}
function extendContext(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const LeafletContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const LeafletProvider = LeafletContext.Provider;
function useLeafletContext() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LeafletContext);
    if (context == null) {
        throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    }
    return context;
}


/***/ }),

/***/ 27999:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ createElementObject; },
/* harmony export */   "I": function() { return /* binding */ createElementHook; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createElementObject(instance, context, container) {
    return Object.freeze({
        instance,
        context,
        container
    });
}
function createElementHook(createElement, updateElement) {
    if (updateElement == null) {
        return function useImmutableLeafletElement(props, context) {
            return (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(createElement(props, context));
        };
    }
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(createElement(props, context));
        const propsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(props);
        const { instance  } = elementRef.current;
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}


/***/ }),

/***/ 51512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dW": function() { return /* binding */ createLayerComponent; },
  "SO": function() { return /* binding */ createOverlayComponent; },
  "Au": function() { return /* binding */ createPathComponent; },
  "Lf": function() { return /* binding */ createTileLayerComponent; }
});

// UNUSED EXPORTS: createControlComponent

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/context.js
var lib_context = __webpack_require__(1410);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/component.js



function createContainerComponent(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance , context  } = useElement(props).current;
        (0,react.useImperativeHandle)(forwardedRef, ()=>instance
        );
        return props.children == null ? null : /*#__PURE__*/ react.createElement(lib_context/* LeafletProvider */.UO, {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0,react.forwardRef)(ContainerComponent);
}
function createDivOverlayComponent(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0,react.useState)(false);
        const { instance  } = useElement(props, setOpen).current;
        (0,react.useImperativeHandle)(forwardedRef, ()=>instance
        );
        (0,react.useEffect)(function updateOverlay() {
            if (isOpen) {
                instance.update();
            }
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0,react_dom.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0,react.forwardRef)(OverlayComponent);
}
function component_createLeafComponent(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance  } = useElement(props).current;
        (0,react.useImperativeHandle)(forwardedRef, ()=>instance
        );
        return null;
    }
    return /*#__PURE__*/ (0,react.forwardRef)(LeafComponent);
}

// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/element.js
var lib_element = __webpack_require__(27999);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/attribution.js

function useAttribution(map, attribution) {
    const attributionRef = (0,react.useRef)(attribution);
    (0,react.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) {
                map.attributionControl.removeAttribution(attributionRef.current);
            }
            if (attribution != null) {
                map.attributionControl.addAttribution(attribution);
            }
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/events.js

function useEventHandlers(element, eventHandlers) {
    const eventHandlersRef = (0,react.useRef)();
    (0,react.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) {
            element.instance.on(eventHandlers);
        }
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) {
                element.instance.off(eventHandlersRef.current);
            }
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/pane.js
var pane = __webpack_require__(81802);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/layer.js





function useLayerLifecycle(element, context) {
    (0,react.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function createLayerHook(useElement) {
    return function useLayer(props) {
        const context = (0,lib_context/* useLeafletContext */.mE)();
        const elementRef = useElement((0,pane/* withPane */.q)(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLayerLifecycle(elementRef.current, context);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/div-overlay.js




function createDivOverlayHook(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0,lib_context/* useLeafletContext */.mE)();
        const elementRef = useElement((0,pane/* withPane */.q)(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/path.js





function usePathOptions(element, props) {
    const optionsRef = (0,react.useRef)();
    (0,react.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function createPathHook(useElement) {
    return function usePath(props) {
        const context = (0,lib_context/* useLeafletContext */.mE)();
        const elementRef = useElement((0,pane/* withPane */.q)(props, context), context);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLayerLifecycle(elementRef.current, context);
        usePathOptions(elementRef.current, props);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/generic.js






function createControlComponent(createInstance) {
    function createElement(props, context) {
        return createElementObject(createInstance(props), context);
    }
    const useElement = createElementHook(createElement);
    const useControl = createControlHook(useElement);
    return createLeafComponent(useControl);
}
function createLayerComponent(createElement, updateElement) {
    const useElement = (0,lib_element/* createElementHook */.I)(createElement, updateElement);
    const useLayer = createLayerHook(useElement);
    return createContainerComponent(useLayer);
}
function createOverlayComponent(createElement, useLifecycle) {
    const useElement = (0,lib_element/* createElementHook */.I)(createElement);
    const useOverlay = createDivOverlayHook(useElement, useLifecycle);
    return createDivOverlayComponent(useOverlay);
}
function createPathComponent(createElement, updateElement) {
    const useElement = (0,lib_element/* createElementHook */.I)(createElement, updateElement);
    const usePath = createPathHook(useElement);
    return createContainerComponent(usePath);
}
function createTileLayerComponent(createElement, updateElement) {
    const useElement = (0,lib_element/* createElementHook */.I)(createElement, updateElement);
    const useLayer = createLayerHook(useElement);
    return component_createLeafComponent(useLayer);
}


/***/ }),

/***/ 81802:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ withPane; }
/* harmony export */ });
function withPane(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane
    } : props;
}


/***/ }),

/***/ 25996:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FeatureGroup; }
/* harmony export */ });
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51512);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27999);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1410);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45243);


const FeatureGroup = (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_1__/* .createPathComponent */ .Au)(function createFeatureGroup({ children: _c , ...options }, ctx) {
    const group = new leaflet__WEBPACK_IMPORTED_MODULE_0__.FeatureGroup([], options);
    return (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .createElementObject */ .O)(group, (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_3__/* .extendContext */ .sj)(ctx, {
        layerContainer: group,
        overlayContainer: group
    }));
});


/***/ }),

/***/ 5715:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ MapContainer; }
/* harmony export */ });
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1410);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45243);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



function MapContainerComponent({ bounds , boundsOptions , center , children , className , id , placeholder , style , whenReady , zoom , ...options }, forwardedRef) {
    const [props] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        className,
        id,
        style
    });
    const [context, setContext] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new leaflet__WEBPACK_IMPORTED_MODULE_0__.Map(node, options);
            if (center != null && zoom != null) {
                map.setView(center, zoom);
            } else if (bounds != null) {
                map.fitBounds(bounds, boundsOptions);
            }
            if (whenReady != null) {
                map.whenReady(whenReady);
            }
            setContext((0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .createLeafletContext */ .Hb)(map));
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .LeafletProvider */ .UO, {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", _extends({}, props, {
        ref: mapRef
    }), contents);
}
const MapContainer = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(MapContainerComponent);


/***/ }),

/***/ 20577:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Marker; }
/* harmony export */ });
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51512);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27999);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1410);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45243);


const Marker = (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_1__/* .createLayerComponent */ .dW)(function createMarker({ position , ...options }, ctx) {
    const marker = new leaflet__WEBPACK_IMPORTED_MODULE_0__.Marker(position, options);
    return (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .createElementObject */ .O)(marker, (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_3__/* .extendContext */ .sj)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) {
        marker.setLatLng(props.position);
    }
    if (props.icon != null && props.icon !== prevProps.icon) {
        marker.setIcon(props.icon);
    }
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) {
        marker.setZIndexOffset(props.zIndexOffset);
    }
    if (props.opacity != null && props.opacity !== prevProps.opacity) {
        marker.setOpacity(props.opacity);
    }
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) {
            marker.dragging.enable();
        } else {
            marker.dragging.disable();
        }
    }
});


/***/ }),

/***/ 32604:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ Popup; }
/* harmony export */ });
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51512);
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27999);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45243);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const Popup = (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .createOverlayComponent */ .SO)(function createPopup(props, context) {
    const popup = new leaflet__WEBPACK_IMPORTED_MODULE_0__.Popup(props, context.overlayContainer);
    return (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_3__/* .createElementObject */ .O)(popup, context);
}, function usePopupLifecycle(element, context, { position  }, setOpen) {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function addPopup() {
        const { instance  } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) {
                setOpen(false);
            }
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) {
                instance.setLatLng(position);
            }
            instance.openOn(context.map);
        } else {
            // Attach to container component
            context.overlayContainer.bindPopup(instance);
        }
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            context.overlayContainer?.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});


/***/ }),

/***/ 52013:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ TileLayer; }
});

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/grid-layer.js
function updateGridLayer(layer, props, prevProps) {
    const { opacity , zIndex  } = props;
    if (opacity != null && opacity !== prevProps.opacity) {
        layer.setOpacity(opacity);
    }
    if (zIndex != null && zIndex !== prevProps.zIndex) {
        layer.setZIndex(zIndex);
    }
}

// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/generic.js + 6 modules
var generic = __webpack_require__(51512);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/pane.js
var pane = __webpack_require__(81802);
// EXTERNAL MODULE: ./node_modules/@react-leaflet/core/lib/element.js
var lib_element = __webpack_require__(27999);
// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(45243);
;// CONCATENATED MODULE: ./node_modules/react-leaflet/lib/TileLayer.js


const TileLayer = (0,generic/* createTileLayerComponent */.Lf)(function createTileLayer({ url , ...options }, context) {
    const layer = new leaflet_src.TileLayer(url, (0,pane/* withPane */.q)(options, context));
    return (0,lib_element/* createElementObject */.O)(layer, context);
}, updateGridLayer);


/***/ })

}]);